
import React, {Component} from 'react';
import {getTranslate, getActiveLanguage} from "react-localize-redux";
import {connect} from "react-redux";
import PropTypes from 'prop-types';

/**
 * import fonts
 */
import FaQuestionCircle from "react-icons/lib/fa/question-circle";
import FaInfoCircle from 'react-icons/lib/fa/info-circle';

/**
 * import actins
 */
import * as actions from "../../actions";

/**
* import components
*/
import PrevNext from '../PrevNext';
import FormInput from '../forms/FormInput';
import FormInputField from '../forms/FormInputField';
import MixForm from '../forms/MixForm';
import ImageContainer from '../image-handler/ImageContainer';
import wtImage from '../../assets/images/wt_2.png';



class StepTwo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="wt-step-2 step-content">
                <div className='row'>
                    <h5 className='col s12' >
                        {this.props.translate('WT.stepTwo.menu.title')}
                    </h5>
                </div>
                <div className="row">
                    <div className="col s11">
                        <FormInput
                            type="checkbox"
                            name="WT.MISSING_WT_ALAZ_checkbox"
                            value={this.props.wt.MISSING_WT_ALAZ_checkbox.CurrentValue}
                            checked={this.props.wt.MISSING_WT_ALAZ_checkbox.CurrentValue === '1'} 
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepTwo.form.armaturenloch')}
                            divClass={"col s12"} />
                    </div>
                    <div className='col s1 right-align'>
                        <FaQuestionCircle className='right-align' style={{fontSize: '20px'}} />
                    </div>
                    <div className="col s12">
                        <div className="col m4">
                            <FormInput
                                type="select"
                                options={this.props.wt.WT_ALAZ.Values.Value}
                                name="WT.WT_ALAZ" 
                                value={this.props.wt.WT_ALAZ.CurrentValue}
                                checked={this.props.wt.WT_ALAZ.CurrentValue}
                                disabled={this.props.wt.MISSING_WT_ALAZ_checkbox.CurrentValue === '0'}
                                divClass="col s12" />
                        </div>
                        <div className="col m4">
                            <FormInput
                                type="select"
                                options={this.props.wt.WT_ALP1.Values.Value}
                                name="WT.WT_ALP1" 
                                value={this.props.wt.WT_ALP1.CurrentValue}
                                checked={this.props.wt.WT_ALP1.CurrentValue}
                                disabled={this.props.wt.WT_ALAZ.CurrentValue !== '1'}
                                divClass="col s12" />
                        </div>
                        <div className="col m4">
                            <FormInput
                                type="select"
                                options={this.props.wt.WT_ALP2.Values.Value}
                                name="WT.WT_ALP2" 
                                value={this.props.wt.WT_ALP2.CurrentValue}
                                checked={this.props.wt.WT_ALP2.CurrentValue}
                                disabled={this.props.wt.WT_ALAZ.CurrentValue !== '2'}
                                divClass="col s12" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col m6">
                        <FormInput
                            type="checkbox"
                            name="WT.MISSING_WT_ALS_checkbox"
                            value={this.props.wt.MISSING_WT_ALS_checkbox.CurrentValue}
                            checked={this.props.wt.MISSING_WT_ALS_checkbox.CurrentValue === '1'} 
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepTwo.form.specialHole')}
                            divClass={"col s12"} />
                    </div>
                    {/*
                    <div className="col m5 valign-wrapper">
                        <FormInputField
                            type="text"
                            name="WT.WT_ALS_T"
                            value={this.props.wt.WT_ALS_T.CurrentValue}
                            disabled={!this.props.wt.MISSING_WT_ALS_checkbox.CurrentValue}
                            placeholder={this.props.translate('WT.stepTwo.form.description')} />
                    </div>
                    */}
                    <div className="col s12">
                        <div className="col m4">
                            <FormInput
                                type="select"
                                options={this.props.wt.WT_ALS.Values.Value}
                                name="WT.WT_ALS" 
                                value={this.props.wt.WT_ALS.CurrentValue}
                                checked={this.props.wt.WT_ALS.CurrentValue}
                                disabled={this.props.wt.MISSING_WT_ALS_checkbox.CurrentValue === '0'}
                                divClass="col s12" />
                        </div>
                        {/*
                        <div className="col m4 offset-m2 valign-wrapper" style={{height: "40px"}}>
                            <p>
                                {this.props.translate('WT.stepTwo.form.drawing')}
                                <i className="material-icons" style={{fontSize: "16px", paddingLeft: "10px"}}>arrow_forward</i>
                            </p>
                        </div>
                        */}
                    </div>
                </div>
                <div className='col s12 center-align'>
                    <ImageContainer
                        image={this.props.image.Image ? this.props.image.Image : ''}
                        name='dwdf'
                        loadingImage={true}
                        height= '100%'/>
                </div>
                <div className="row">
                    <div className="col m6">
                        <FormInput
                            type="checkbox"
                            name="WT.MISSING_SSPV_checkbox"
                            value={this.props.wt.MISSING_SSPV_checkbox.CurrentValue}
                            checked={this.props.wt.MISSING_SSPV_checkbox.CurrentValue === '1'}
                            disabled={this.props.wt.SSPV.CurrentValue === '0'}
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepTwo.form.soapDispenser')}
                            divClass={"col s12"} />
                    </div>
                    <div className="col m6">
                        <FormInput
                            type="checkbox"
                            name="WT.ST"
                            value={this.props.wt.ST.CurrentValue}
                            checked={this.props.wt.ST.CurrentValue === '1'}
                            disabled={this.props.wt.STV.CurrentValue === '0'}
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepTwo.form.socket')}
                            divClass={"col s12"} />
                    </div>
                    <div className="col s4">
                        <div className="col s12">
                            <FormInput
                                type="select"
                                options={this.props.wt.SSP.Values.Value}
                                name="WT.SSP"
                                value={this.props.wt.SSP.CurrentValue}
                                checked={this.props.wt.SSP.CurrentValue}
                                disabled={this.props.wt.MISSING_SSPV_checkbox.CurrentValue === '0'}
                                divClass="col s12" />
                        </div>
                    </div>
                    <div className="col m6 offset-m2">
                        <div className="col s12">
                            <FormInput
                                type="select"
                                options={this.props.wt.STP.Values.Value}
                                name="WT.STP"
                                value={this.props.wt.STP.CurrentValue}
                                checked={this.props.wt.STP.CurrentValue}
                                disabled={this.props.wt.ST.CurrentValue !== '1'}
                                divClass="col s12" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col m6 offset-m6">
                        <FormInput
                            type="checkbox"
                            name="WT.HTH"
                            value={this.props.wt.HTH.CurrentValue}
                            checked={this.props.wt.HTH.CurrentValue === '1'}
                            disabled={this.props.wt.HTHV.CurrentValue === '0'}
                            labelPosition="inline"
                            labelName={this.props.translate('WT.stepTwo.form.towerHolder')}
                            divClass={"col s12"} />
                    </div>
                </div>
            </div>
        );
    }

}

StepTwo.propTypes = {
    translate: PropTypes.func,
}


function mapStateToProps({locale, wt, image}) {
    return {
        translate: getTranslate(locale),
        wt,
        image,
    }
}

export default connect(mapStateToProps, actions)(StepTwo);



// WEBPACK FOOTER //
// ./src/components/wt-steps/StepTwo.js